module.exports = __webpack_public_path__ + "img/9791159254314.df8ec91d.jpg";